<template>
  <component
    :is="tag"
    :class="[
      'iconButton',
      {
        'iconButton--noBorder': noBorder,
        'iconButton--bigger': bigger,
        'iconButton--colored': colored,
        'iconButton--disabled': disabled,
        'iconButton--text': text,
      },
    ]"
    :to="to"
    :href="href"
    :type="tag === 'button' ? 'button' : ''"
    :disabled="disabled"
    @click="onClick"
  >
    <span
      v-if="icon"
      :class="[`icon-${icon}`, 'iconButton__icon', { 'iconButton__icon--table': tableIcon }]"
    />
    <span v-if="text" class="iconButton__text">
      {{ text }}
    </span>
  </component>
</template>

<script>
export default {
  name: 'IconButton',
  props: {
    to: {
      type: String,
      default: undefined,
    },
    href: {
      type: String,
      default: undefined,
    },
    text: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    tableIcon: {
      type: Boolean,
      default: false,
    },
    colored: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bigger: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.to) {
        return 'nuxt-link';
      } else if (this.href) {
        return 'a';
      } else {
        return 'button';
      }
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.iconButton {
  $root: &;
  width: 2.5rem;
  height: 2.5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border: 1px solid $cAddLight;
  border-radius: 3px;

  &--noBorder {
    border: none;
  }

  &--text {
    width: auto !important;
    padding: 0 1rem;
    color: $cMain;
    transition: border $tr;

    #{$root}__icon {
      color: $cMain;
      font-size: 1.3rem !important;
    }

    &:hover {
      border: 1px solid $cMain;

      #{$root}__icon {
        color: $cMain !important;
      }
    }
  }

  &__text {
    margin-left: 0.5rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 700;
  }

  &--colored {
    width: 4rem;
    height: 4rem;
    border-radius: 4px;
    background-color: #582c83;
  }

  &--disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &--bigger {
    width: 3rem;
    height: 3rem;

    #{$root}__icon {
      font-size: 1.6rem;
    }
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    color: $cWhite;
    transition: color $tr;

    &--table {
      font-size: 2.8rem;
      color: $cAddNeutral;
    }
  }

  &:hover {
    #{$root}__icon {
      color: $cSec;
    }
  }
}
</style>
